// extracted by mini-css-extract-plugin
export default {"OpenSampleListPage":"OpenSampleListPage_OpenSampleListPage__kg7S0"};